<script setup>
import { useCalendar } from '@daysmart/daysmart-vue-components/composables'
import { useCalendarListViewScrollspyState } from '../composables/useCalendarListViewScrollspyState'
import { useCalendarSettings } from '../composables/useCalendarSettings'

const props = defineProps(['date', 'eventDates'])
const emit = defineEmits(['selectDate'])

const { customFirstDayOfWeek } = useCalendarSettings()
const calendar = useCalendar({ customFirstDayOfWeek })
const week = computed(() => calendar.getWeekView.value(props.date))

const { calendarListViewScrollspyState } = useCalendarListViewScrollspyState()

function isSelectedDay(day) {
  return props.date === day.format('YYYY-MM-DD')
}

function hasEvent(day) {
  return props.eventDates?.includes(day.format('YYYY-MM-DD'))
}

function isToday(day) {
  return day.format('YYYY-MM-DD') === calendar.today.value.format('YYYY-MM-DD')
}

function selectDate(value) {
  emit('selectDate', value)
  calendarListViewScrollspyState.value = value
}
</script>

<template>
  <div
    class="mb-2 w-full flex content-evenly rounded bg-surface-200 p-2 ring-1 ring-surface-600 ring-inset sm:!hidden"
  >
    <button
      v-for="day in week"
      :key="day.format('YYYY-MM-DD')"
      class="flex flex-1 flex-col items-center"
      @click="selectDate(day.format('YYYY-MM-DD'))"
    >
      <p class="mb-4px text-xs text-text-300 fw-semibold">
        {{ day.format('ddd').slice(0, 1) }}
      </p>
      <p
        class="text-medium wh-26px flex items-center justify-center"
        :class="{
          '!bg-secondary rounded-1/2 text-white fw-600': isSelectedDay(day),
          'bg-secondary-100 rounded-1/2 border border-secondary-200 ':
            isToday(day),
        }"
      >
        <span
          :class="{
            'border-b border-primary w-75% ':
              hasEvent(day) && !isSelectedDay(day) && !isToday(day),
            'underline underline-offset-2px':
              (isSelectedDay(day) || isToday(day)) & hasEvent(day),
          }"
        >
          {{ day.format('D') }}
        </span>
      </p>
    </button>
  </div>

  <div class="m-2 mt-0 h-44px min-w-470px flex overflow-x-auto lt-sm:!hidden">
    <button
      v-for="day in week"
      :key="day.format('YYYY-MM-DD')"
      class="flex flex-1 items-center justify-center whitespace-nowrap px-4 py-3 text-text-500"
      :class="{
        '!bg-secondary rounded-1.5': isSelectedDay(day),
        'bg-primary-100 b-2 b-color-primary rounded-8px': isToday(day),
      }"
      @click="selectDate(day.format('YYYY-MM-DD'))"
    >
      <span
        class="mr-1 text-sm font-semibold"
        :class="{ 'text-white': isSelectedDay(day) }"
      >
        {{ day.format('ddd') }}
      </span>
      <span
        class="text-sm font-semibold"
        :class="{ 'text-white': isSelectedDay(day) }"
      >
        {{ day.format('D') }}
      </span>
    </button>
  </div>
</template>
